// EditStudent Component for update student data 

// Import Modules 
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import axios from "axios";
import { useLocation } from "react-router-dom";
import PatientDiagnosisForm from "../Forms/PatientDiagnosisForm";
import CONFIG from '../../config';
import { usePatient } from "../../context/PatientContext";
import { useAuth } from "../../context/AuthProvider";


// EditStudent Component 
const EditPatientDiagnosis = () => {
  const { markSectionComplete } = useOutletContext() ;  
  const navigate = useNavigate();
  const { verifyTokenAndRedirect } = useAuth();
  const { patientData, setPatientData, selectedCase, selectedVisit, doctorInfo } = usePatient();
  const {patientId, caseId, visitId} = useParams();
  const location = useLocation();


  useEffect(() => {

    verifyTokenAndRedirect();

  }, []);


  //onSubmit handler 
  const onSubmitHandler = (updatedPatientDiagnosis) => {


    console.log("selected Visit after submit:", updatedPatientDiagnosis); // Log the data to be updated

    // const updatedData = {
    //   ...patientData,
    //   patientDiagnosis: [{ ...updatedPatientDiagnosis }] // Overwrite patientInfo while keeping other data unchanged
    // };

    // const updatedData = {
    //   ...patientData, 
    //   patientDiagnosis: patientData.patientDiagnosis.map(info => ({
    //       ...info, // Keep existing patientInfo fields
    //       ...updatedPatientDiagnosis // Merge updated fields
    //   }))
    // };

  //   const updatedData = {
  //     ...patientData,
  //     patientDiagnosis: patientData.patientDiagnosis.length > 0 
  //         ? patientData.patientDiagnosis.map(info => ({
  //             ...info, // Keep existing patientInfo fields
  //             ...updatedPatientDiagnosis // Merge updated fields
  //         }))
  //         : [updatedPatientDiagnosis] // If empty, create a new array with updatedPatientDiagnosis
  // };

  const updatedData = {
    ...patientData,
    patientDiagnosis: patientData?.patientDiagnosis?.length > 0 
        ? patientData.patientDiagnosis.map(info => ({
            ...info, // Keep existing patientInfo fields
            ...updatedPatientDiagnosis, // Merge updated fields
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId, // Add CASE_ID if missing
            VISIT_ID: selectedVisit || visitId,  // Add VISIT_ID if missing
            DOCTOR_ID: doctorInfo.MANDALI_ID,
            CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
    
        }))
        : [{
            ...updatedPatientDiagnosis,
            PATIENT_ID: patientData.PATIENT_ID, 
            CASE_ID: selectedCase || caseId,  // Default CASE_ID if not provided
           VISIT_ID: selectedVisit || visitId, // Default VISIT_ID if not provided
           DOCTOR_ID: doctorInfo.MANDALI_ID,
           CLINIC_ID: doctorInfo.CLINIC_ID // Merge updated fields
   
        }]
  };
    

    setPatientData(updatedData);
    markSectionComplete("diagnosis");
    if (location.pathname.startsWith("/addpatient")) {
      navigate("/addpatient/treatment");
    } else if (location.pathname.startsWith("/visits")) {
      navigate(`/visits/${patientId}/${caseId}/${visitId}/treatment`);
    } else {
      console.warn("Unknown route, no redirection");
    }


  };


  // Return student form 
  return (

    <div>
      {console.log('inside rendering: ', patientData)}
      {patientData && (
        <PatientDiagnosisForm
          initialValues={patientData}
          onSubmit={onSubmitHandler}
          enableReinitialize={true}
        >
          Update Patient
        </PatientDiagnosisForm>
      )}
    </div>
  );

};

export default EditPatientDiagnosis;

